import ConnectProvideDocumentSimpleForm from './ConnectProvideDocumentSimpleForm'

export default ConnectProvideDocumentSimpleForm
